<ng-container *ngIf="widget">
  <div class="switch-container">
    <smart-input [(model)]="widget" hintTranslationPrefix="packages.installedWidgets.hints" key="disabled"
                 translationPrefix="packages.installedApps"></smart-input>
    <div class="disable-display">
      <p>{{ 'packages.installedApps.displayDisable'| translate }}</p>
      <mat-checkbox [(ngModel)]="widget.screenDisabled">Screen</mat-checkbox>
      <mat-checkbox [(ngModel)]="widget.mobileDisabled">Mobile</mat-checkbox>
    </div>
    <smart-input [(model)]="widget" hintTranslationPrefix="packages.installedWidgets.hints" key="default"
                 translationPrefix="packages.installedWidgets"></smart-input>
    <smart-input [(model)]="widget" hintTranslationPrefix="packages.installedWidgets.hints" key="mobileDefault"
                 translationPrefix="packages.installedWidgets"></smart-input>
  </div>

  <ng-container *ngIf="!!pak?.ibexTablet?.enabled">
    <mat-tab-group>
      <mat-tab label="ibextouch/ibexsmart">
        <div class="seasonal-images-container">
          <div class="seasonal-image" *ngFor="let element of widget.seasonalImages; let i = index">
            <img *ngIf="element.imagePath" [src]="imageAssetPath + element.imagePath + '/' + 'oneToOne'"/>
            <smart-input [(model)]="widget.seasonalImages[i]" format="dd-mm" key="from" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
            <smart-input [(model)]="widget.seasonalImages[i]" format="dd-mm" key="to" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
            <button (click)="removeSeasonalImage(i)" mat-icon-button><mat-icon>delete</mat-icon></button>
          </div>
          <button (click)="addSeasonalImage()" class="ibexfusion-raised-button" mat-button>{{ 'packages.images.add' | translate }}</button>
        </div>

        <div class="select-group">
          <smart-input (onChange)="changeType($event)" [(model)]="widget.translations[0]" [hideDescription]="true" key="widgetStyle" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
          <button (click)="resetWidgetStyle()" *ngIf="widget.translations[0].widgetStyle" mat-icon-button><mat-icon>delete</mat-icon></button>
        </div>

        <mat-tab-group (selectedTabChange)="tabChange($event)">
          <mat-tab *ngFor="let translation of widget.translations; let i = index" [label]="translation.language">
            <div>
              <div class="input-group default">
                <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="title" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
                <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="subtitle" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
              </div>
              <div class="input-group iframe">
                <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.translations[i]" [hideDescription]="true" key="iframe" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
                <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.translations[i]" [hideDescription]="true" key="backgroundColor" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
              </div>
            </div>
            <editor (changeContent)="quillChanged($event, translation.language)" *ngIf="translation.widgetStyle === 'imageText'" [content]="translation.content" [options]="editorOptions" height="200px"></editor>
          </mat-tab>
        </mat-tab-group>

        <ng-container *ngIf="superadmin">
          <mat-expansion-panel class="code-area">
            <mat-expansion-panel-header>
              <mat-panel-title>widgetEntryDetail</mat-panel-title>
              <mat-panel-description>Expand to edit</mat-panel-description>
            </mat-expansion-panel-header>
            <code-area [options]="codeEditorOptions" [parent]="widget" [value]="widget.detail" key="detail" type="json"></code-area>
          </mat-expansion-panel>
        </ng-container>
      </mat-tab>
      <mat-tab label="ibextablet">
        <div class="seasonal-images-container">
          <div class="seasonal-image" *ngFor="let element of widget.tabletWidgetConfig.seasonalImages; let i = index">
            <img *ngIf="element.imagePath" [src]="imageAssetPath + element.imagePath + '/' + 'oneToOne'"/>
            <smart-input [(model)]="widget.tabletWidgetConfig.seasonalImages[i]" format="dd-mm" key="from" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
            <smart-input [(model)]="widget.tabletWidgetConfig.seasonalImages[i]" format="dd-mm" key="to" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
            <button (click)="removeSeasonalImage(i, true)" mat-icon-button><mat-icon>delete</mat-icon></button>
          </div>
          <button (click)="addSeasonalImage(true)" class="ibexfusion-raised-button" mat-button>{{ 'packages.images.add' | translate }}</button>
        </div>

        <div class="select-group">
          <smart-input (onChange)="changeType($event, 'tablet')" [(model)]="widget.tabletWidgetConfig.translations[0]" [hideDescription]="true" key="widgetStyle" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
          <button (click)="resetWidgetStyle('tablet')" *ngIf="widget.tabletWidgetConfig.translations[0].widgetStyle" mat-icon-button><mat-icon>delete</mat-icon></button>
        </div>

        <mat-tab-group (selectedTabChange)="tabChange($event)">
          <mat-tab *ngFor="let translation of widget.tabletWidgetConfig.translations; let i = index" [label]="translation.language">
            <div>
              <div class="input-group default">
                <smart-input [(model)]="widget.tabletWidgetConfig.translations[i]" [hideDescription]="true" key="title"
                             translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
                <smart-input [(model)]="widget.tabletWidgetConfig.translations[i]" [hideDescription]="true" key="subtitle"
                             translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
              </div>
              <div class="input-group iframe">
                <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.tabletWidgetConfig.translations[i]" [hideDescription]="true"
                             key="iframe" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
                <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.tabletWidgetConfig.translations[i]" [hideDescription]="true"
                             key="backgroundColor" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
              </div>
            </div>
            <editor (changeContent)="quillChanged($event, translation.language)" *ngIf="translation.widgetStyle === 'imageText'"
                              [content]="translation.content" [options]="editorOptions"
                              height="200px"></editor>
          </mat-tab>
        </mat-tab-group>

        <ng-container *ngIf="superadmin">
          <mat-expansion-panel class="code-area">
            <mat-expansion-panel-header>
              <mat-panel-title>widgetEntryDetail</mat-panel-title>
              <mat-panel-description>Expand to edit</mat-panel-description>
            </mat-expansion-panel-header>
            <code-area [options]="codeEditorOptions" [parent]="widget" [value]="widget.tabletWidgetConfig.detail" key="detail" type="json"></code-area>
          </mat-expansion-panel>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-container *ngIf="!pak?.ibexTablet?.enabled">
    <div class="seasonal-images-container">
      <div class="seasonal-image" *ngFor="let element of widget.seasonalImages; let i = index">
        <img *ngIf="element.imagePath" [src]="imageAssetPath + element.imagePath + '/' + 'oneToOne'"/>
        <smart-input [(model)]="widget.seasonalImages[i]" format="dd-mm" key="from" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
        <smart-input [(model)]="widget.seasonalImages[i]" format="dd-mm" key="to" translationPrefix="packages.images" [hideDescription]="true"></smart-input>
        <button (click)="removeSeasonalImage(i)" mat-icon-button><mat-icon>delete</mat-icon></button>
      </div>
      <button (click)="addSeasonalImage()" class="ibexfusion-raised-button" mat-button>{{ 'packages.images.add' | translate }}</button>
    </div>

    <div class="select-group">
      <smart-input (onChange)="changeType($event)" [(model)]="widget.translations[0]" [hideDescription]="true" key="widgetStyle" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
      <button (click)="resetWidgetStyle()" *ngIf="widget.translations[0].widgetStyle" mat-icon-button><mat-icon>delete</mat-icon></button>
    </div>

    <mat-tab-group (selectedTabChange)="tabChange($event)">
      <mat-tab *ngFor="let translation of widget.translations; let i = index" [label]="translation.language">
        <div>
          <div class="input-group default">
            <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="title"
                         translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
            <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="subtitle"
                         translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
          </div>
          <div class="input-group default" *ngIf="!!pak?.ibexApp?.enabled">
            <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="flagTitle"
                         translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
            <smart-input [(model)]="widget.translations[i]" [hideDescription]="true" key="flagColor"
                         translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
          </div>
          <div class="input-group iframe">
            <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.translations[i]" [hideDescription]="true"
                         key="iframe" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
            <smart-input *ngIf="translation.widgetStyle === 'iframe'" [(model)]="widget.translations[i]" [hideDescription]="true"
                         key="backgroundColor" translationPrefix="packages.installedWidgets.widgetTypes"></smart-input>
          </div>
        </div>
        <editor (changeContent)="quillChanged($event, translation.language)" *ngIf="translation.widgetStyle === 'imageText'"
                          [content]="translation.content" [options]="editorOptions"
                          height="200px"></editor>
      </mat-tab>
    </mat-tab-group>

    <ng-container *ngIf="superadmin">
      <mat-expansion-panel class="code-area">
        <mat-expansion-panel-header>
          <mat-panel-title>widgetEntryDetail</mat-panel-title>
          <mat-panel-description>Expand to edit</mat-panel-description>
        </mat-expansion-panel-header>
        <code-area [options]="codeEditorOptions" [parent]="widget" [value]="widget.detail" key="detail" type="json"></code-area>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>

  <button (click)="saveWidget()" class="ibexfusion-raised-button" mat-button>
    <mat-icon>save</mat-icon>
    {{ 'packages.installedWidgets.save' | translate }}
  </button>

</ng-container>
